import { classNames } from "../../../utils"

interface Option<T extends string> {
  value: T
  label: string
}

interface Props<T extends string> {
  options: Option<T>[]
  value: T
  onChange: (value: T) => void
  /** Names the control for assistive tech — "Progress view". */
  label: string
}

/** A panel-scoped view switch. One look for every toggle on the Stats page. */
const StatsSegmented = <T extends string>({
  options,
  value,
  onChange,
  label
}: Props<T>) => (
  <div
    role="group"
    aria-label={label}
    className="inline-flex max-w-full flex-wrap rounded-lg bg-slate-100 p-0.5 text-xs font-medium"
  >
    {options.map(option => (
      <button
        key={option.value}
        type="button"
        aria-pressed={value === option.value}
        onClick={() => onChange(option.value)}
        className={classNames(
          "whitespace-nowrap rounded-md px-3 py-1.5 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-200",
          value === option.value
            ? "bg-white text-base-dark shadow-sm"
            : "text-slate-500 hover:text-base-dark"
        )}
      >
        {option.label}
      </button>
    ))}
  </div>
)

export default StatsSegmented
